/**
 * コレクションページのインフィニティスクロール
 *
 * main-collection-product-grid セクションの「スクロールで自動読み込み」が
 * ONのときだけ動く。セクションが出力する [data-infinite-scroll] を起点に、
 * paginate.next.url を section_id 付きで取得して #product-grid に追記する。
 *
 * JS が動かない／取得に失敗した場合は通常のページ番号ページネーション
 * ([data-infinite-fallback]) がそのまま残るため、表示が壊れることはない。
 */
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-infinite-scroll]';
  var GRID_SELECTOR = '#product-grid';
  var CONTAINER_SELECTOR = '#ProductGridContainer';
  var LOAD_MARGIN = 600; // px。この距離まで近づいたら次ページを読み込む

  // 画面から この距離（ビューポート比）より外に出たカードの画像を捨てる。
  // 商品を読み進めるほど画像が積み上がり、iPhone の Safari が
  // メモリ上限でタブごと再読み込みする（＝ページトップに飛ぶ）ため。
  var RECYCLE_MARGIN = '150% 0px';
  var BLANK_SRC = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

  // 商品ページから戻ったときに、読み込み済みの件数とスクロール位置を復元するための保存先
  var STATE_PREFIX = 'c-infinite-scroll:';
  var STATE_TTL = 30 * 60 * 1000; // 30分。これより古い記録は使わない

  var current = null;
  var firstInit = true;

  /**
   * Coming Soon ラベルを付ける。
   *
   * テーマ側（snippets/card-product.liquid の末尾のインラインscript）は
   * DOMContentLoaded のときに一度 .is-coming-soon を集めてラベルを作るだけなので、
   * あとから追記したカードには付かない（追記したHTML内のscriptも実行されない）。
   * 同じDOMをここで作る。既に付いているカードには触らない。
   */
  function applyComingSoonLabels(scope) {
    var cards = (scope || document).querySelectorAll('.is-coming-soon');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.getElementsByClassName('coming-soon-label').length) continue;

      var label = document.createElement('div');
      label.className = 'coming-soon-label';
      var startDate = card.getAttribute('data-sales-start');

      if (startDate) {
        label.appendChild(document.createTextNode('Coming Soon :)'));
        label.appendChild(document.createElement('br'));
        var dateWrap = document.createElement('span');
        dateWrap.className = 'coming-soon-date';
        var prefix = document.createElement('span');
        prefix.className = 'release-prefix';
        prefix.textContent = '*Release on ';
        dateWrap.appendChild(prefix);
        dateWrap.appendChild(document.createTextNode(startDate));
        label.appendChild(dateWrap);
      } else {
        label.textContent = 'Coming Soon :)';
      }

      card.appendChild(label);
    }
  }

  /**
   * ラベルの二重付与を掃除する。
   * テーマ側のインラインscript（DOMContentLoaded・重複チェック無し）と
   * こちらの付与が前後したときに、同じカードに2枚付くことがあるため。
   */
  function dedupeComingSoonLabels(scope) {
    var cards = (scope || document).querySelectorAll('.is-coming-soon');
    for (var i = 0; i < cards.length; i++) {
      var labels = cards[i].getElementsByClassName('coming-soon-label');
      while (labels.length > 1) {
        labels[labels.length - 1].parentNode.removeChild(labels[labels.length - 1]);
      }
    }
  }

  /** 絞り込み・並び替えが違えば別の状態として扱う（page だけ無視する） */
  function stateKey() {
    var params = new URLSearchParams(window.location.search);
    params.delete('page');
    params.sort();
    var q = params.toString();
    return STATE_PREFIX + window.location.pathname + (q ? '?' + q : '');
  }

  function readState(key) {
    try {
      var raw = window.sessionStorage.getItem(key);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.pages || Date.now() - data.ts > STATE_TTL) return null;
      return data;
    } catch (e) {
      return null;
    }
  }

  function writeState(key, data) {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(data));
    } catch (e) {
      // プライベートブラウズなどで書けないことがある。復元を諦めるだけで表示には影響しない
    }
  }

  /**
   * 画面から遠いカードの画像を外してメモリを解放する。
   * <img> の width/height 属性と CSS の比率指定はそのまま残すので、
   * 外している間もカードの高さは変わらない（＝スクロール位置がずれない）。
   */
  function ImageRecycler(grid) {
    this.grid = grid;
    this.observer = null;
  }

  ImageRecycler.prototype.start = function () {
    if (!('IntersectionObserver' in window) || !this.grid) return;
    var self = this;
    this.observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) self.restore(entries[i].target);
          else self.unload(entries[i].target);
        }
      },
      { rootMargin: RECYCLE_MARGIN }
    );
    this.watchNewItems();
  };

  /** まだ監視していないカードを監視下に入れる（追加読み込みのたびに呼ぶ） */
  ImageRecycler.prototype.watchNewItems = function () {
    if (!this.observer) return;
    var items = this.grid.querySelectorAll('.grid-item');
    for (var i = 0; i < items.length; i++) {
      if (items[i].getAttribute('data-recycle-watched') === 'true') continue;
      items[i].setAttribute('data-recycle-watched', 'true');
      this.observer.observe(items[i]);
    }
  };

  ImageRecycler.prototype.unload = function (item) {
    var imgs = item.getElementsByTagName('img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.getAttribute('data-recycled') === 'true') continue;
      // まだ読み込まれていない画像（lazy のまま）は触らない
      if (!img.currentSrc) continue;
      img.setAttribute('data-recycle-src', img.getAttribute('src') || '');
      img.setAttribute('data-recycle-srcset', img.getAttribute('srcset') || '');
      img.setAttribute('data-recycled', 'true');
      img.removeAttribute('srcset');
      img.setAttribute('src', BLANK_SRC);
    }
  };

  ImageRecycler.prototype.restore = function (item) {
    var imgs = item.getElementsByTagName('img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.getAttribute('data-recycled') !== 'true') continue;
      var srcset = img.getAttribute('data-recycle-srcset');
      var src = img.getAttribute('data-recycle-src');
      if (srcset) img.setAttribute('srcset', srcset);
      if (src) img.setAttribute('src', src);
      img.removeAttribute('data-recycled');
      img.removeAttribute('data-recycle-src');
      img.removeAttribute('data-recycle-srcset');
    }
  };

  ImageRecycler.prototype.destroy = function () {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  };

  function InfiniteScroll(root) {
    this.root = root;
    this.sectionId = root.getAttribute('data-section-id');
    this.nextUrl = root.getAttribute('data-next-url') || '';
    this.grid = document.querySelector(GRID_SELECTOR);
    this.sentinel = root.querySelector('[data-infinite-sentinel]');
    this.button = root.querySelector('[data-infinite-button]');
    this.spinner = root.querySelector('[data-infinite-spinner]');
    this.errorEl = root.querySelector('[data-infinite-error]');
    this.fallback = document.querySelector('[data-infinite-fallback]');
    this.loading = false;
    this.observer = null;
    this.recycler = new ImageRecycler(this.grid);
    this.onClick = this.load.bind(this);

    this.pagesLoaded = 1;
    this.afterLoad = null;   // 1ページ分の追記が終わったら呼ぶ（復元中の直列読み込み用）
    this.restoring = false;  // 復元中はスクロール連動の追い読みをしない
    this.stateKey = stateKey();
    this.onPageHide = this.saveState.bind(this);
  }

  InfiniteScroll.prototype.start = function () {
    if (!this.grid || !this.sectionId || !this.nextUrl) return;

    // JS が動いたときだけ「もっと見る」を出し、ページ番号を引っ込める
    this.root.classList.remove('hidden');
    this.root.classList.add('flex');
    if (this.fallback) this.fallback.classList.add('hidden');

    if (this.button) this.button.addEventListener('click', this.onClick);

    if ('IntersectionObserver' in window && this.sentinel) {
      var self = this;
      this.observer = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) self.load();
          }
        },
        { rootMargin: LOAD_MARGIN + 'px 0px' }
      );
      this.observer.observe(this.sentinel);
      // 自動で読み込めるならボタンは出さない（読み込み中のスピナーだけ見せる）。
      // IntersectionObserver が無い環境でだけボタンが残る
      if (this.button) this.button.classList.add('hidden');
    }

    this.recycler.start();

    // 離脱時に「何ページ目まで読んだか」と位置を控えておく
    window.addEventListener('pagehide', this.onPageHide);

    this.restoreFromHistory();
  };

  /**
   * 商品ページなどから戻ってきたとき、前回と同じ件数まで読み直して位置を戻す。
   * これをしないと、戻るたびに1ページ目（24件）に巻き戻ってしまう。
   */
  InfiniteScroll.prototype.restoreFromHistory = function () {
    // 2ページ目以降を直接開いている場合は、そのページが正なので触らない
    if (new URLSearchParams(window.location.search).get('page')) return;

    var saved = readState(this.stateKey);
    if (!saved || saved.pages <= 1) return;

    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    var self = this;
    this.restoring = true;
    this.setBusy(true);

    var step = function () {
      if (self.pagesLoaded >= saved.pages || !self.nextUrl) {
        self.restoring = false;
        self.setBusy(false);
        var max = Math.max(0, document.body.scrollHeight - window.innerHeight);
        window.scrollTo(0, Math.min(saved.y || 0, max));
        return;
      }
      self.afterLoad = step;
      self.load();
    };
    step();
  };

  InfiniteScroll.prototype.saveState = function () {
    if (this.pagesLoaded <= 1) return;
    writeState(this.stateKey, {
      pages: this.pagesLoaded,
      y: Math.round(window.scrollY),
      ts: Date.now(),
    });
  };

  InfiniteScroll.prototype.load = function () {
    if (this.loading || !this.nextUrl) return;
    this.loading = true;
    this.setBusy(true);

    var url;
    try {
      url = new URL(this.nextUrl, window.location.href);
    } catch (e) {
      this.fail();
      return;
    }
    url.searchParams.set('section_id', this.sectionId);

    var self = this;
    fetch(url.toString())
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        self.append(html);
      })
      .catch(function () {
        self.fail();
      });
  };

  InfiniteScroll.prototype.append = function (html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newGrid = doc.querySelector(GRID_SELECTOR);
    var newRoot = doc.querySelector(ROOT_SELECTOR);

    if (!newGrid || !newGrid.firstElementChild) {
      this.fail();
      return;
    }

    var fragment = document.createDocumentFragment();
    while (newGrid.firstElementChild) {
      fragment.appendChild(newGrid.firstElementChild);
    }
    applyComingSoonLabels(fragment);
    this.grid.appendChild(fragment);
    window.setTimeout(dedupeComingSoonLabels, 0);
    this.recycler.watchNewItems();

    this.nextUrl = (newRoot && newRoot.getAttribute('data-next-url')) || '';
    this.pagesLoaded += 1;
    this.loading = false;
    if (!this.restoring) this.setBusy(false);

    if (!this.nextUrl) this.finish();

    var done = this.afterLoad;
    this.afterLoad = null;
    if (done) {
      done();
      return;
    }

    if (!this.nextUrl) return;

    // 追記しても番兵がまだ視界に入っている場合（画面が縦に長い等）は続けて読む。
    // IntersectionObserver は「交差状態の変化」でしか発火しないため。
    var self = this;
    window.setTimeout(function () {
      if (!self.sentinel || !self.nextUrl || self.restoring) return;
      if (self.sentinel.getBoundingClientRect().top < window.innerHeight + LOAD_MARGIN) {
        self.load();
      }
    }, 100);
  };

  InfiniteScroll.prototype.setBusy = function (busy) {
    if (this.spinner) this.spinner.classList.toggle('hidden', !busy);
    if (this.button) {
      this.button.disabled = busy;
      this.button.classList.toggle('opacity-50', busy);
    }
    this.grid.setAttribute('aria-busy', busy ? 'true' : 'false');
  };

  /** 全件読み終わった。操作部ごと片付ける */
  InfiniteScroll.prototype.finish = function () {
    this.destroy();
    if (this.sentinel) this.sentinel.remove();
    this.root.classList.remove('flex');
    this.root.classList.add('hidden');
  };

  /** 取得に失敗した。ページ番号ページネーションに戻して手動で進めるようにする */
  InfiniteScroll.prototype.fail = function () {
    this.loading = false;
    this.restoring = false;
    this.afterLoad = null;
    this.setBusy(false);
    this.destroy();
    if (this.button) this.button.classList.add('hidden');
    if (this.sentinel) this.sentinel.remove();
    if (this.errorEl) this.errorEl.classList.remove('hidden');
    if (this.fallback) this.fallback.classList.remove('hidden');
  };

  /** 追加読み込みだけ止める。画像のリサイクルは読み終わった後も続ける */
  InfiniteScroll.prototype.destroy = function () {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    if (this.button) this.button.removeEventListener('click', this.onClick);
  };

  /** 絞り込みなどでグリッドごと差し替わるときは、画像のリサイクルも畳む */
  InfiniteScroll.prototype.teardown = function () {
    this.destroy();
    if (this.recycler) this.recycler.destroy();
    window.removeEventListener('pagehide', this.onPageHide);
  };

  function init() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root || root.getAttribute('data-infinite-ready') === 'true') return;
    if (current) current.teardown();
    root.setAttribute('data-infinite-ready', 'true');
    current = new InfiniteScroll(root);
    current.start();

    if (!firstInit) applyComingSoonLabels(document.getElementById('product-grid'));
    firstInit = false;
  }

  /**
   * 絞り込み・並び替え（facets.js）は #ProductGridContainer の innerHTML を
   * 丸ごと差し替えるので、差し替え後にもう一度組み立て直す。
   */
  var containerObserver = null;

  function watchContainer() {
    var container = document.querySelector(CONTAINER_SELECTOR);
    if (!container || typeof MutationObserver === 'undefined') return;
    if (containerObserver) containerObserver.disconnect();
    containerObserver = new MutationObserver(function () {
      init();
    });
    containerObserver.observe(container, { childList: true });
  }

  function boot() {
    init();
    watchContainer();
  }

  function scheduleDedupe() {
    window.setTimeout(dedupeComingSoonLabels, 0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
    // テーマ側のラベル付与も DOMContentLoaded なので、そのあとに掃除する
    document.addEventListener('DOMContentLoaded', scheduleDedupe);
  } else {
    boot();
    scheduleDedupe();
  }

  // テーマエディタでセクション設定を変更したとき
  document.addEventListener('shopify:section:load', boot);

  // bfcache から復帰したときはDOMもスクロール位置もそのまま残っているので、何もしない
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    if (current) current.setBusy(false);
  });
})();
